var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component html"},[(_vm.sources)?_vm._l((_vm.sources),function(source){return _c('div',{domProps:{"innerHTML":_vm._s(_vm.variableSwapWithSource(_vm.content, source))}})}):[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }